import { render, staticRenderFns } from "./forbidden-page.vue?vue&type=template&id=5a5c342f"
import script from "./forbidden-page.vue?vue&type=script&lang=ts"
export * from "./forbidden-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5c342f')) {
      api.createRecord('5a5c342f', component.options)
    } else {
      api.reload('5a5c342f', component.options)
    }
    module.hot.accept("./forbidden-page.vue?vue&type=template&id=5a5c342f", function () {
      api.rerender('5a5c342f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forbidden-page/forbidden-page.vue"
export default component.exports